import React from 'react'
import Cookies from 'js-cookie'

export const COOKIE_USER_SETTING = 'pgads_user_setting_'
export const COOKIE_SETTING = { path: '/', expires: 180 }

const getCookieName = userName => COOKIE_USER_SETTING + (userName || '')

const userSetting = { zoom: 100, fontColor: undefined, darkMode: false }

const getUserSettingFromCookie = userName => {
  // some times its create without userName
  Cookies.remove(COOKIE_USER_SETTING)

  const userCookieSetting = Cookies.get(getCookieName(userName))
  return JSON.parse(userCookieSetting || JSON.stringify(userSetting))
}

const setUserSettingInCookie = (userName, objValue) => {
  if (userName)
    Cookies.set(
      getCookieName(userName),
      { ...getUserSettingFromCookie(userName), ...objValue },
      COOKIE_SETTING
    )
}

const setZoomInCookie = (userName, zoom) => {
  setUserSettingInCookie(userName, { zoom })
}
const getZoomFromCookie = userName => {
  return getUserSettingFromCookie(userName).zoom
}

const setFontColorInCookie = (userName, fontColor) => {
  setUserSettingInCookie(userName, { fontColor })
}
const getfontColorFromCookie = userName => {
  return getUserSettingFromCookie(userName).fontColor
}

const setDarkmodeInCookie = (userName, darkMode) => {
  setUserSettingInCookie(userName, { darkMode })
}

const getDarkmodeFomrCookie = userName => {
  return getUserSettingFromCookie(userName).darkMode
}

export {
  getUserSettingFromCookie,
  setZoomInCookie,
  getZoomFromCookie,
  setFontColorInCookie,
  getfontColorFromCookie,
  setDarkmodeInCookie,
  getDarkmodeFomrCookie,
}
